export default {
  Empty: "Trống",
  FormatStringChange:
    'Đổi&nbsp;<span class="field">{0}</span>&nbsp;từ&nbsp;<span class="oldValue">{1}</span>&nbsp;thành&nbsp;<span class="newValue">{2}</span>',
  Master: {
    FormatStringModeAddOrDelete: " {0} ({1}), {2}: {3}",
    FormatStringModeAddOrDeleteString:
      "###AssetName### (###AssetCode###), ###FieldToLower_Quantity###: ###Quantity###",
  },
  List: {
    Title: "Nhật ký truy cập",
    Search: "Tìm kiếm nhật ký truy cập",
    UserName: "Người dùng",
    LogTime: "Ngày giờ",
    EntityName: "Đối tượng thao tác",
    Action: "Hành động",
    Reference: "Tham chiếu",
    Description: "Mô tả",
    ClientIP: "Địa chỉ IP",
  },
  asset: {
    Master: {
      PreFix: "Tài sản: {0} \n</br>",
      FormatStringModeAddOrDeleteString:
        "###AssetName### (###AssetCode###), ###FieldToLower_Quantity###: ###Quantity###",
      FormatString: " {0} ({1}), {2}: {3}",
    },
    Detail: [
      {
        module: "", //module của detail là gì
      },
    ],
  },
  assetType: {
    Master: {
      FormatStringModeAddOrDeleteString: "###AssetTypeName### (###AssetTypeCode###)",
    },
  },
  transfer: {
    Master: {
      PreFix: "Tài sản: {0} \n</br>",
      FormatStringModeAddOrDeleteString:
        "###AssetName### (###AssetCode###), ###FieldToLower_Quantity###: ###Quantity### từ ###FromTransfer### đến ###ToTransfer###",
      FormatString: " {0} ({1}), {2}: {3}",
    },
  },
  usageHistory: {
    Master: {
      FormatStringModeAddOrDeleteString:
        "###AssetName### (###AssetCode###), ###FieldToLower_Quantity###: ###Quantity###",
    },
  },
  reduce: {
    Master: {
      FormatStringModeAddOrDeleteString:
        "###AssetName### (###AssetCode###), ###FieldToLower_Quantity###: ###Quantity### từ ###EmployeeCode### ###FullName###",
    },
  },
  allocation: {
    Master: {
      FormatStringModeAddOrDeleteString:
        "###AssetName### (###AssetCode###), ###FieldToLower_Quantity###: ###Quantity### cho ###EmployeeCode### ###FullName###",
    },
  },
};
